module.exports = __webpack_public_path__ + "static/media/offc-refine-fans.343a5041.png";